(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l2-buy-options')) {
    customElements.define('l2-buy-options', class extends HTMLElement {
      connectedCallback() {
        this.idInput = this.querySelector('[data-buy-id]');
        this.qtyInput = this.querySelector('[data-buy-qty]');
        this.submit = this.querySelector('.product-form__submit');
        this.format = this.dataset.moneyFormat || '{{amount_with_comma_separator}}';
        try { this.tiers = JSON.parse(this.dataset.tiers || '[]'); } catch (e) { this.tiers = []; }
        this.saveText = this.dataset.save || '__PCT__%';
        this.addEventListener('change', (event) => {
          if (event.target.matches('input[name="buy_option"]')) this.select(event.target.closest('[data-buy-option]'));
          if (event.target.matches('[data-buy-count]')) this.update();
        });
        this.select(this.querySelector('[data-buy-option][data-selected]') || this.querySelector('[data-buy-option]'), true);
      }
      money(cents) {
        const fixed = (cents / 100).toFixed(2);
        const [whole, dec] = fixed.split('.');
        const dots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const commas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => ({
          amount: `${commas}.${dec}`,
          amount_no_decimals: commas,
          amount_with_comma_separator: `${dots},${dec}`,
          amount_no_decimals_with_comma_separator: dots,
        }[key] ?? `${dots},${dec}`));
      }
      select(card, initial) {
        if (!card) return;
        this.current = card;
        this.querySelectorAll('[data-buy-option]').forEach((c) => c.toggleAttribute('data-selected', c === card));
        const radio = card.querySelector('input[name="buy_option"]');
        if (radio) radio.checked = true;
        if (this.idInput) this.idInput.value = card.dataset.variant;
        if (!initial) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', card.dataset.variant);
          window.history.replaceState({}, '', url);
        }
        this.update();
      }
      update() {
        const card = this.current;
        if (!card) return;
        const count = parseInt(card.querySelector('[data-buy-count]')?.value || '1', 10);
        const bottles = parseInt(card.dataset.qty, 10) * count;
        if (this.qtyInput) this.qtyInput.value = String(bottles);
        const unit = parseInt(card.dataset.unit, 10);
        const pct = this.tiers.reduce((best, t) => (bottles >= t.qty && t.pct > best ? t.pct : best), 0);
        let price = unit * bottles;
        let compare = parseInt(card.dataset.compareUnit || '0', 10) * bottles;
        let shown = 0;
        if (pct > 0) {
          compare = price;
          price = Math.round((price * (100 - pct)) / 100);
          shown = pct;
        } else if (compare > price) {
          shown = Math.floor(((compare - price) * 100) / compare);
        }
        const now = card.querySelector('[data-buy-now]');
        const was = card.querySelector('[data-buy-compare]');
        const save = card.querySelector('[data-buy-save]');
        if (now) now.textContent = this.money(price);
        if (was) was.textContent = compare > price ? this.money(compare) : '';
        if (save) {
          save.hidden = shown <= 0;
          save.textContent = shown > 0 ? this.saveText.replace('__PCT__', shown) : '';
        }
        if (this.submit) this.submit.disabled = card.hasAttribute('data-disabled');
        document.querySelectorAll('[data-sticky-price]').forEach((el) => { el.textContent = this.money(price); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l2-mobile-menu')) {
    customElements.define('l2-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.toggleEl = this.querySelector('summary');
        this.details.addEventListener('toggle', () => this.onToggle());
        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-view-open]');
          if (opener) { event.preventDefault(); this.showView(opener.dataset.viewOpen, opener); return; }
          if (event.target.closest('[data-cart-open]')) this.close();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) { this.close(); this.toggleEl.focus(); }
        });
        window.addEventListener('resize', () => this.details.open && this.setTop());
      }
      setTop() {
        const header = this.closest('.site-header') || this;
        this.style.setProperty('--mobile-menu-top', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
      }
      onToggle() {
        this.toggleEl.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
        if (this.details.open) this.setTop(); else this.showView('main');
      }
      showView(name, opener) {
        this.querySelectorAll('[data-view]').forEach((view) => { view.hidden = view.dataset.view !== name; });
        this.querySelectorAll('.mobile-menu__item[data-view-open]').forEach((btn) => {
          btn.setAttribute('aria-expanded', btn.dataset.viewOpen === name ? 'true' : 'false');
        });
        const views = this.querySelector('.mobile-menu__views');
        if (views) views.scrollTop = 0;
        if (opener) {
          const target = this.querySelector('[data-view="' + name + '"] ' + (name === 'main' ? '[data-view-open]' : '.mobile-menu__back'));
          if (target) target.focus();
        }
      }
      close() { this.details.open = false; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
